export default __webpack_public_path__ + "static/media/mail.72b1738e.svg";